import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../contexts/AuthContext';
import Icon from '../../components/AppIcon';

const PLANS = [
  { id: 'crm', name: 'Starter CRM', price: 29, icon: 'LayoutDashboard', color: 'from-blue-500 to-blue-600', highlight: false },
  { id: 'crm_voice', name: 'CRM + Voice', price: 59, icon: 'PhoneCall', color: 'from-green-500 to-green-600', highlight: false },
  { id: 'crm_voice_website', name: 'CRM + Voice + Website', price: 99, icon: 'Globe', color: 'from-emerald-500 to-emerald-600', highlight: true },
  { id: 'crm_voice_website_marketing', name: 'Full Suite', price: 149, icon: 'Sparkles', color: 'from-orange-500 to-pink-500', highlight: false },
];

const PaywallPage = () => {
  const navigate = useNavigate();
  const { organization, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <Helmet>
        <title>Trial Ended — Wilcart CRM</title>
      </Helmet>
      {/* Logo */}
      <div className="flex items-center justify-center mb-8">
        <img
          src="/assets/images/wilcart_logo_1-1775846328647.png"
          alt="Wilcart CRM Logo"
          className="h-12 w-auto object-contain"
        />
        <span className="ml-3 text-2xl font-bold text-foreground">Wilcart</span>
      </div>
      {/* Main card */}
      <div className="w-full max-w-2xl bg-card border border-border rounded-2xl p-8 shadow-xl text-center mb-6">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Lock" size={28} className="text-amber-600" />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">Your trial has ended</h1>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          Your 14-day free trial for <strong>{organization?.name || 'your organization'}</strong> has expired.
          Choose a plan below to continue using Wilcart CRM.
        </p>

        {/* Plans grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
          {PLANS?.map((plan) => (
            <div
              key={plan?.id}
              className={`relative p-4 rounded-xl border-2 text-left transition-all ${
                plan?.highlight
                  ? 'border-primary bg-primary/5 shadow-md'
                  : 'border-border bg-background hover:border-primary/30'
              }`}
            >
              {plan?.highlight && (
                <div className="absolute -top-2.5 left-1/2 -translate-x-1/2">
                  <span className="px-2 py-0.5 text-xs font-bold bg-primary text-primary-foreground rounded-full whitespace-nowrap">
                    Most Popular
                  </span>
                </div>
              )}
              <div className={`w-8 h-8 rounded-lg bg-gradient-to-br ${plan?.color} flex items-center justify-center mb-2`}>
                <Icon name={plan?.icon} size={16} className="text-white" />
              </div>
              <p className="text-xs font-semibold text-foreground leading-tight mb-1">{plan?.name}</p>
              <p className="text-lg font-bold text-foreground">${plan?.price}<span className="text-xs font-normal text-muted-foreground">/mo</span></p>
            </div>
          ))}
        </div>

        <button
          onClick={() => navigate('/billing')}
          className="w-full py-3 bg-primary text-primary-foreground rounded-xl font-semibold text-base hover:bg-primary/90 transition-colors flex items-center justify-center space-x-2"
        >
          <Icon name="CreditCard" size={18} />
          <span>Choose a Plan & Continue</span>
        </button>
      </div>
      {/* Footer actions */}
      <div className="flex items-center space-x-4 text-sm text-muted-foreground">
        <button
          onClick={() => navigate('/billing')}
          className="hover:text-foreground transition-colors"
        >
          View all plans
        </button>
        <span>·</span>
        <button
          onClick={handleSignOut}
          className="hover:text-foreground transition-colors"
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default PaywallPage;
